<div class="col-lg-8">
    <h5>Cambiar Contraseña</h5>
    <br>
    <div class="jumbotron">
        <div *ngIf="errorpreguntas==true;" class="alert alert-danger alert-dismissible fade show" role="alert">
            <strong>Respuestas incorrectas!</strong> Reintente por favor..
        </div>
        <p>
            Conteste sus preguntas personales, luego haga click en <b>Validar Datos</b> para elegir su nueva contraseña
        </p>
        <form>
            <div class="form-row">
                <div>
                    <label for="pre1">Pregunta 1) <b>{{pre1be}}</b></label>
                    <input [(ngModel)]="res1fe" name="res1fe" type="text" class="form-control">
                    <label for="pre2">Pregunta 2) <b>{{pre2be}}</b></label>
                    <input [(ngModel)]="res2fe" name="res2fe" type="text" class="form-control">
                </div>
            </div>
        </form>
        <br>
        <button [disabled]="res1fe==null || res2fe==null" (click)="validarPreguntas()" routerLinkActive="router-link-active" type="button" class="btn btn-success btn-lg">
          Validar Datos!
        </button>
    </div>
</div>

<!-- Boton trigger MODAL CHANGUE PASS -->
<button hidden id="abremodalpass" type="button" class="btn btn-success" data-toggle="modal" data-target="#modalChanguePass">
        Olvido / cambiar Contraseña.. 
</button>


<!-- Modal COMPLETAR FORMULARIO -->
<div data-backdrop="static" data-keyboard="false" style="margin-top: 60px" class="modal fade" id="modalChanguePass" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div id="modalChanguePass" class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="modalChanguePass">¡Datos validados correctamente!</h5>
                <button hidden type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
            </div>
            <div class="modal-body">

                <div *ngIf="error==true;" class="alert alert-danger alert-dismissible fade show" role="alert">
                    <strong>Las contraseñas ingresadas no coinciden!</strong> Reintente por favor..
                </div>

                <P>
                    A continuación, Ingrese su nueva contraseña, y repitala en el segundo casillero.
                </P>
                <div id="carguita">
                    <div class="col-lg-6">
                        <label class="col" for="pass">Nueva Contraseña</label>
                        <input [(ngModel)]="newpass1" name="newpass1" type="password" class="form-control">
                        <label class="col" for="pass2">Repitala aquí..</label>
                        <input [(ngModel)]="newpass2" name="newpass2" type="password" class="form-control">
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button id="cierraModal" data-dismiss="modal" type="button" class="btn btn-secondary">CANCELAR</button>
                <button [disabled]="newpass1==null || newpass2==null" (click)="validarPass()" type="button" class="btn btn-success">
                    Guardar Cambios!
                    <i *ngIf="loading2==true" class="fa fa-spinner fa-spin fa-1x fa-fw"></i>
                </button>
            </div>
        </div>
    </div>
</div>